import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.2 12.634V.8h-.8v11.834l-2.517-2.517-.566.566L4.8 14.165l3.483-3.482-.566-.566L5.2 12.634zM14.4 3.2H8V4h6.4v-.8zM9.6 7.6h4.8v.8H9.6v-.8zm4.8 4.4h-3.2v.8h3.2V12z" fill="#000" /></svg>;